import { useContext } from "react"
import { IntercomContext } from "./IntercomProvider"

export function useIntercom() {
    return useContext(IntercomContext)
}
